/* UTILITIES */
export const GET_MARKETPLACE_AUCTIONS_BY_CLIENT_METHOD = 'getMarketplaceAuctionsByClientMethod';
export const GET_AUCTION_FROM_VUEX_BY_AUCTION_ID = 'getAuctionFromVuexByAuctionId';
export const GET_AUCTIONS_FROM_VUEX_BY_AUCTION_IDS = 'getAuctionsFromVuexByAuctionIds';
export const ASSIGN_COLLECTION_KEYS_TO_AUCTIONS = 'assignCollectionKeysToAuctions';
export const REMOVE_COLLECTION_KEYS_FROM_AUCTIONS = 'removeCollectionKeysFromAuctions';
export const SET_AUCTION_VISIBILITY = 'setAuctionVisibility';
export const ADD_AUCTIONS = 'addAuctions';
export const REMOVE_AUCTIONS = 'removeAuctions';
export const UPDATE_AUCTIONS = 'updateAuctions';
export const CLEAR_AUCTIONS = 'clearAuctions';
export const UPDATE_HAS_MORE_PAGES = 'updateHasMorePages';
export const UPDATE_AUCTION_LANES_REFRESHING = 'updateAuctionLanesRefreshing';
export const SYNC_AUCTIONS_DATA = 'syncAuctionsData';
export const GET_AUCTIONS_DATA = 'getAuctionsData';
export const SUBSCRIBE_MARKETPLACE_AUCTIONS = 'subscribeMarketplaceAuctions';
export const UPDATE_SELECTED_AUCTION_LANE = 'updateSelectedAuctionLane';
export const UPDATE_SELECTED_AUCTION_LANE_SUB_FILTER = 'updateSelectedAuctionLaneSubFilter';
export const UPDATE_AD_HOC_SEARCH_IS_ACTIVE = 'updateAdHocSearchIsActive';
export const UPDATE_SAVED_SEARCH_IS_ACTIVE = 'updateSavedSearchIsActive';
export const HANDLE_BID_MESSAGE = 'handleBidMessage';
export const HANDLE_BID_API_RESPONSE = 'handleBidApiResponse';
export const HANDLE_END_MESSAGE = 'handleEndMessage';
export const HANDLE_ENDED_UPDATE_MESSAGE = 'handleEndedUpdateMessage';
export const HANDLE_KILLED_MESSAGE = 'handleKilledMessage';
export const UNSUBSCRIBE_MARKETPLACE_AUCTIONS = 'unsubscribeMarketplaceAuctions';
export const GET_LEGACY_CARFAX_ALERTS_ON_AUCTION = 'getLegacyCarfaxAlertsOnAuction';
export const LOAD_VIEWING_AUCTION_MODEL = 'loadViewingAuctionModel';
export const UPDATE_VIEWING_AUCTION_MODEL = 'updateViewingAuctionModel';
export const CLEAR_VIEWING_AUCTION_MODEL = 'clearViewingAuctionModel';
export const REFRESH_VIEWING_AUCTION_MODEL = 'refreshViewingAuctionModel';
export const UPDATE_LEGACY_AUCTION_RANK_IN_LIST = 'updateLegacyAuctionRankInList';
export const SUBSCRIBE_GRAPHQL_MARKETPLACE_AUCTIONS = 'subscribeGraphqlMarketplaceAuctions';
export const RETAIN_GRAPHQL_SUBSCRIPTION = 'retainGraphqlSubscription';
export const HANDLE_GRAPHQL_UPDATE = 'handleGraphqlUpdate';
export const CLEAR_GRAPHQL_SUBSCRIPTIONS = 'clearGraphqlSubscriptions';
export const FETCH_ADDITIONAL_DATA = 'fetchAdditionalData';
export const RESOLVE_SIDEBAR_COLLECTION_KEYS = 'resolveSidebarCollectionKeys';
export const UPDATE_AUCTION_BID_INCREMENT = 'updateAuctionBidIncrement';
/* UTILITIES */
